module.exports = __webpack_public_path__ + "img/zk-icon-system.4d42162d.svg";